// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","774":"framework"}[chunkId] || chunkId) + "-" + {"36":"db0bbf4d4672d099927a","231":"2b77a16d6c6f27847c62","532":"7601f4a510e943eae33a","678":"4dea7e20bb561cdac216","774":"a1bae3c680f4215bef6f"}[chunkId] + ".js";
};